import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { FIRM } from "@/lib/firm";
import { Motion, CM_CSS } from "@/pages/CollateralMotion";
import { Packet, PK_CSS } from "@/pages/MotionPacket";
import { TroDoc, TRO_CSS, troFieldsFromApp } from "@/pages/TroMotion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CODE2NAME = { GA: "Georgia", NC: "North Carolina", SC: "South Carolina", TN: "Tennessee", FL: "Florida", AL: "Alabama", TX: "Texas", VA: "Virginia" };
const todayISO = () => new Date().toISOString().slice(0, 10);

function buildShared(app) {
  const acct = {};
  const v = app.loan_account_no || app.account_no || app.loan_number || "";
  if (v) acct[app.id] = v;
  const saved = app.motion_doc_settings || {};
  const stateName = CODE2NAME[(app.property_state || "").toUpperCase()] || saved.state || "Tennessee";
  return {
    state: stateName, county: app.property_county || "", courtType: "", caseNo: "",
    plaintiff: "SEUTRADE FINANCIAL SERVICES, on behalf of the Borrower,",
    standstillDate: "", receivedDate: "", deliveryEvidence: "email delivery confirmation and/or certified mail receipt",
    repName: FIRM.officer, repTitle: "Authorized Representative", repAddress: FIRM.address,
    repPhone: "", repEmail: "seutradeinfo@gmail.com", lenderCounsel: "",
    serviceMethod: "", execDate: todayISO(), serviceDate: todayISO(),
    causeOfAction: "", amountNote: "", juryDemand: "No — equitable relief requested",
    payoffDays: "ten (10)",
    ...saved,
    acct: { ...acct, ...(saved.acct || {}) },
  };
}

// Public, token-signed print route for headless-Chrome PDF rendering / court eFax.
export default function PrintMotion() {
  const { type, appId } = useParams();
  const t = new URLSearchParams(useLocation().search).get("t");
  const [app, setApp] = useState(null);

  useEffect(() => {
    if (!appId || !t) return;
    (async () => {
      try {
        const r = await axios.get(`${API}/borrower/applications/${appId}/public?t=${encodeURIComponent(t)}`);
        setApp(r.data.application || {});
      } catch { /* leave blank */ }
    })();
  }, [appId, t]);

  if (!app) return <div style={{ padding: 40, fontFamily: "serif" }}>Loading…</div>;

  let body, css;
  if (type === "collateral") {
    body = <div className="paper-sheet"><Motion app={app} shared={buildShared(app)} /></div>;
    css = CM_CSS;
  } else if (type === "tro") {
    body = <TroDoc f={troFieldsFromApp(app)} />;
    css = TRO_CSS;
  } else {
    body = <Packet app={app} shared={buildShared(app)} idx={0} last />;
    css = PK_CSS;
  }

  return (
    <div style={{ background: "#fff" }}>
      <div className="cm-print-area">{body}</div>
      <style>{css}</style>
    </div>
  );
}
